import { Ajaxinate } from 'ajaxinate';

export default (node) => {
  const init = () => {
    const endlessScroll = new Ajaxinate({
      container: '.AjaxinateContainerCollectionAllTemplate',
      pagination: '.AjaxinatePaginationCollectionAllTemplate',
      loadingText: 'Loading more....',
    });
  };

  init();
};
